import { init } from './sentry/common';

init();
